import React, { useContext } from "react";
import { userContext } from "../Context/userContext";

const SideBar = () => {
  const { setcontentType, ShowMenu, setShowMenu } = useContext(userContext);

  const go = (type) => {
    setcontentType(type);
    setShowMenu(!ShowMenu);
  };

  const lifestyle = [{ type: "BMI", icon: "🧮", label: "BMI & Calories" }];

  const funTools = [
    { type: "love", icon: "💘", label: "Love Calculator" },
    { type: "daysalive", icon: "🎂", label: "Days Alive Counter" },
    { type: "water", icon: "💧", label: "Water Intake" },
    { type: "sleep", icon: "😴", label: "Ideal Sleep" },
    { type: "tip", icon: "🧾", label: "Tip Calculator" },
    { type: "whichlynx", icon: "🐾", label: "Which Lynx Are You?" },
  ];

  const content = [
    { type: "image", icon: "🖼️", label: "Images" },
    { type: "audio", icon: "🎵", label: "Music" },
    { type: "wallpaper", icon: "🌄", label: "Wallpapers" },
    { type: "zoom", icon: "🖥️", label: "Zoom Backgrounds" },
  ];

  const games = [
    { type: "BHGame", icon: "🕳️", label: "Black Hole Game" },
    { type: "AllGames", icon: "🕹️", label: "All Games!" },
  ];

  const renderTiles = (items) => (
    <div className="sidebar-tile-grid">
      {items.map((item) => (
        <button
          key={item.type}
          className="sidebar-tile"
          onClick={() => go(item.type)}
        >
          <span className="sidebar-tile-icon">{item.icon}</span>
          {item.label}
        </button>
      ))}
    </div>
  );

  return (
    <div className="sidebar">
      <div className="d-flex flex-column p-3 text-white">
        <div className="d-flex align-items-center justify-content-between mb-3">
          <span className="fs-4">Menu</span>
          <button
            className="sidebar-close-btn"
            aria-label="Close menu"
            onClick={() => setShowMenu(!ShowMenu)}
          >
            ✕
          </button>
        </div>

        <button className="sidebar-highlight" onClick={() => go("home")}>
          🏠 Home
        </button>

        <button
          className="sidebar-highlight"
          onClick={() => go("winners")}
        >
          🏆 Winner Check
        </button>

        <span className="sidebar-section-title">Lifestyle 💪</span>
        {renderTiles(lifestyle)}

        <span className="sidebar-section-title">Fun Tools 🎉</span>
        {renderTiles(funTools)}

        <span className="sidebar-section-title">Content 🎁</span>
        {renderTiles(content)}

        <span className="sidebar-section-title">Games 🕹️</span>
        {renderTiles(games)}
      </div>
    </div>
  );
};

export default SideBar;
